<template>
  <Design :customFonts="customFonts">
    <div :class="settingScreenSize.device">
      <div
        id="displayDevice"
        :ref="`displayDevice`"
        :class="`h-100 ${settingScreenSize.deviceDisplay}`"
      >
        <Skeleton :screenSize="screenSize" v-if="loading">
          <SkeletonMobile v-if="screenSize === 'Mobile'" />
          <SkeletonTablet v-else-if="screenSize === 'Tablet'" />
          <SkeletonDesktop v-else />
        </Skeleton>
        <div id="displayDeviceWrapper" class="w-100 h-100" style="overflow: hidden;">
          <iframe
            v-show="!loading"
            :class="`viewport${screenSize} ${changeScreen ? 'changing' : 'changed'}` "
            @load="loaded"
            id="viewport"
            :ref="`viewport`"
            height="100%"
            :style="{
              '--iframe-scale': iframeScale,
              transform: `scale(${iframeScale})`,
              'transform-origin': 'top left',
              height: `calc(100%/${iframeScale})`,
              width: `calc(100%/${iframeScale})`,
            }"
            :src="buildDate ? `design-iframe?v=${Date.parse(buildDate)}` : 'design-iframe'"
          >
          </iframe>
        </div>
      </div>
      <div :class="settingScreenSize.device1"></div>
      <div :class="settingScreenSize.device2"></div>
      <div :class="settingScreenSize.device3"></div>
      <div :class="settingScreenSize.device4"></div>
    </div>
    <ManagePage />
    <Social />
    <Html />
    <ManageHeaderMenu />
    <TopMenu />
    <ManageFooterMenu />
    <FacebookLikeBox />
    <ModalUpdateFontStyle />
    <Filemanager ref="filemanager"></Filemanager>
    <AddLink2 />
    <AddLinkWidget />
    <AddSlideSection />
    <AddTabItem />
    <CannotAddWidgetAlert />
    <ModalPublish/>
    <CannotAddWidgetAlertInSlide />
    <ModalFontAwesome />
    <ModalConfirmWarning />
    <CannotAddGridAlert />
    <ModalAIInsufficientCredit v-if="permissionCurrency" />
    <ModalAICloseConfirm v-if="permissionCurrency" />
    <!-- <AddPage
      :action="action"
      :id="item_id"
      :templateData="templateData"
      @clear="clear"
      @scrollToPage="scrollToPage"
    /> -->
    <AddMenu
      idModal="designAddMMenuModal"
      :action="action"
      :pageId="item_id"
      @clear="(action = ''), (item_id = '')"
      @scrollToMenu="scrollToMenu"
    />
  </Design>
</template>

<script>
import { mapGetters } from "vuex";
import { Design, Skeleton } from "./Design.styled";
import SkeletonDesktop from "@components_system/Design/Skeleton/SkeletonDesktop";
import SkeletonTablet from "@components_system/Design/Skeleton/SkeletonTablet";
import SkeletonMobile from "@components_system/Design/Skeleton/SkeletonMobile";

import ManagePage from "@components_system/Design/Modal/ManagePage/ManagePage";
import Social from "@components_system/Design/Modal/Widget/Social/Social";
import ManageHeaderMenu from "@components_system/Design/Modal/Header/ManageMenu/ManageMenu";
import TopMenu from "@components_system/Design/Modal/Widget/Header/TopMenu/TopMenu";
import ManageFooterMenu from "@components_system/Design/Modal/Footer/ManageMenu/ManageMenu";
import FacebookLikeBox from "@components_system/Design/Modal/Widget/Footer/FacebookLikeBox/FacebookLikeBox";
import ModalUpdateFontStyle from "@components_system/Design/Modal/ModalUpdateFontStyle/ModalUpdateFontStyle.vue";
import AddLink2 from "@components/dynamic/widget/tool/Modal/AddLink2/AddLink.vue";
import AddLinkWidget from "@components/dynamic/widget/tool/Modal/AddLink/AddLink.vue";
import AddSlideSection from "@components_system/Design/Modal/AddSlideSection/AddSlideSection.vue"
import CannotAddWidgetAlert from "@components_system/Design/Modal/Widget/Alert/CannotAddWidgetAlert";
import CannotAddWidgetAlertInSlide from "@components_system/Design/Modal/Widget/Alert/CannotAddWidgetAlertInSlide"
import ModalPublish from "@components_system/Design/Modal/Publish/Publish";
import AddMenu from "@components_system/Design/Modal/Header/AddMenu/AddMenu";
import Html from "@components_system/Design/Modal/Widget/Html/Html";
import ModalFontAwesome from "@components_system/Design/Modal/FontAwesome/FontAwesome";
import ModalConfirmWarning from "@components_system/Design/Modal/Types/ModalConfirmWarning";
import AddTabItem from "@components_system/Design/Modal/AddTabItem/AddTabItem";
import CannotAddGridAlert from "@components_system/Design/Modal/Grid/Alert/CannotAddGridAlert";
import ModalAIInsufficientCredit from "@components_system/Design/Modal/ModalAIInsufficientCredit/ModalAIInsufficientCredit";
import ModalAICloseConfirm from "@components_system/Design/Modal/ModalAICloseConfirm/ModalAICloseConfirm";

import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

import hotkeys from "hotkeys-js";
export default {
  components: {
    Design,
    Skeleton,
    SkeletonDesktop,
    SkeletonTablet,
    SkeletonMobile,
    ManagePage,
    Social,
    ManageHeaderMenu,
    TopMenu,
    ManageFooterMenu,
    FacebookLikeBox,
    ModalUpdateFontStyle,
    AddLink2,
    AddLinkWidget,
    AddSlideSection,
    CannotAddWidgetAlert,
    CannotAddWidgetAlertInSlide,
    ModalPublish,
    AddMenu,
    Html,
    ModalFontAwesome,
    ModalConfirmWarning,
    AddTabItem,
    CannotAddGridAlert,
    ModalAIInsufficientCredit,
    ModalAICloseConfirm,
  },
  data() {
    return {
      text: "",
      loading: true,
      iframeScale: 1,
      iframeWin: undefined,
      changeScreen: false,
      action: "",
      item_id: "",
      templateData : {},
      date : 1000*60*60*24,
    };
  },

  mounted() {
    this.initShortkey();
    let iframeWin = document.getElementById("viewport").contentWindow;
    this.iframeWin = iframeWin;
    this.$store.dispatch("design/registerFilemanager", {
      filemanager: this.$refs.filemanager,
    });
    this.$store.dispatch("design/page/fetchPublishStatus");
    this.$store.dispatch("design/page/initialiseDesignIFrame", { iframeWin });

    this.handleResize();
    if (this.$route.query.action == 'add_page') {
      this.$bvModal.show("modal-select-template-page");
    } else if (this.$route.query.action == 'add_cart_button') {
      this.elActive({ elementID: 'header' })
    }
  },
  watch: {
    screenSize: function () {
      this.changeScreen = true
      setTimeout(this.handleResize, 400);
    },
    screenWidth: function () {
      this.handleResize();
    },
    tempLogs() {
      this.setLogsLocal();
    },
    getListPage() {
      if (this.$route.query.action == 'add_header_menu' && this.getListPage.length > 0) {
        this.addHeaderMenu();
      }
    }
  },
  methods: {
    setLogsLocal() {
      if(this.tempLogs && this.tempLogs.length) {
        const timeElapsed = Date.now();
        const today = new Date(timeElapsed);
        const date = today.toUTCString();

        const newLog = { [timeElapsed] : {
          date : date,
          status : '',
          logs : this.tempLogs
        }};
        
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${this.domainDisplay}`));

        if(oldLog) {
          Object.keys(oldLog).map(key => {
            const day = Math.floor((timeElapsed - key) / this.date);
            if(day >= 2) {
              delete oldLog[key];
            }
          });
        }

        const tempLog = {...oldLog,...newLog};

        localStorage.setItem(`LOG_${this.domainDisplay}`,JSON.stringify(tempLog));
        this.$store.dispatch('design/snapshot/setTempLogs',undefined);
      }
    },
    loaded() {
      this.loading = false;
    },
    registerHotkeys(key, callback) {
      hotkeys(key, (event) => {
        // Prevent the default refresh event under WINDOWS system
        event.preventDefault();
        callback();
      });
    },
    initShortkey() {
      this.registerHotkeys("command+z,ctrl+z", () =>
        this.$store.dispatch("design/snapshot/undo")
      );
      this.registerHotkeys("ctrl+y,command+y,command+shift+z", () =>
        this.$store.dispatch("design/snapshot/redo")
      );
    },

    handleResize() {
      // desktop min width 1366
      const scale = this.$refs.displayDevice.clientWidth / 1366;
      this.iframeScale = scale < 1 && this.screenSize === "Desktop" ? scale : 1;
      this.$store.dispatch("design/setIframeScale", { iframeScale: this.iframeScale })

      setTimeout(() => {
        this.$store.dispatch("designIframe/setIframeScale", { iframeScale: this.iframeScale })
        this.$store.dispatch("designIframe/frame/reRenderFrame")
        this.changeScreen = false
      }, 400);
    },
    addHeaderMenu() {
      if(this.getListPage.length > 0) {
        const pageTerms = this.getListPage.filter(item => item.properties.type == "terms_condition")[0];
        if (pageTerms) {        
          this.action = "add";
          this.item_id = pageTerms.id
          this.$bvModal.show("designAddMMenuModal");
        }
        
      }
    },
    clear() {
      this.action = "";
      this.item_id = "";
      this.text = "";
    },
    async scrollToMenu(value) {
      if (value) {
        this.loading = true;
        const timer = setInterval(() => {
          let $elem = document.getElementById("page-item-" + value);
          if ($elem) {
            this.loading = false;
            clearInterval(timer);
            setTimeout(() => {
              $elem.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
              // $elem.classList.add("page-item-last");
            }, 100); // delay for dom render
          }
        }, 1);
      }
    },
    elActive({ elementID }) {
      setTimeout(() => {
        if (elementID == "header" || elementID == "footer") {
          // Header or Footer Section
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {
            component_id: elementID == "header" ? "comp-HEADER" : "FOOTER",
            name: elementID == "header" ? "HEADER" : "FOOTER",
          });
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
          this.$store.dispatch("designIframe/frame/setSectionHover", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {});
          this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
          this.$store.dispatch("design/component/elActive", { elementID });
        } else {
          if (this.components[elementID[1]] && this.components[elementID[1]].type == "SLIDE_SECTION") {
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
              component_id: elementID[1],
              index: 0,
            });
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("design/component/elActive", { elementID: [
              ...elementID, this.components[elementID[1]].componentsID[0]
            ] });
          } else {
            // Other Section
            if (elementID && elementID != 'website_theme') {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: elementID[1],
                name: elementID[1],
              });
            }
            
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});

            if (elementID)
              this.$store.dispatch("design/component/scrollToId", {
                elementID,
                behavior: "smooth",
              });
      
            let noneSetting = false;
      
            SECTION_TYPE_NONE_SETTING.find((type) => {
              Object.entries(this.components).forEach((item) => {
                if (type === item[1].type && item[1].id === elementID[1]) {
                  noneSetting = true;
                }
              });
            });
            if (noneSetting) {
              this.$store.dispatch("design/component/elActive", {});
            } else {
              this.$store.dispatch("design/component/elActive", { elementID });
            }
          }
        }
      }, 100);
    },
  },
  computed: {
    ...mapGetters({
      elActiveID: "design/component/elActiveID",
      screenSize: "screenSize",
      screenWidth: "screenWidth",
      sections: "design/page/sections",
      customFonts: "design/site/customFonts",
      domains: "design/site/domains",
      logs: "design/snapshot/logs",
      logsIndex: "design/snapshot/logsIndex",
      tempLogs: "design/snapshot/tempLogs",
      siteComponents: "design/metadata/siteComponents",
      currencyMain: "design/page/currencyMain",
    }),
    domainDisplay() {
      return this.domains.main;
    },
    strLogs() {
      return JSON.stringify(this.logs);
    },
    settingScreenSize() {
      switch (this.screenSize) {
        case "Mobile":
          return {
            device: "device device-iphone-x",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-btns",
            device3: "device-power",
            device4: "device-home",
          };
        case "Tablet":
          return {
            device: "device device-ipad-pro device-spacegray",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-header",
            device3: "device-sensors",
            device4: "device-btns",
          };

        default:
          return {
            device: "device device-desktop h-100",
            deviceDisplay: "device-frame drop-shadow",
          };
      }
    },
    buildDate() {
      return process.env.VUE_APP_BUILDDATE;
    },
    getListPage() {
      var object_list = [];
      if (this.siteComponents) {
        Object.entries(JSON.parse(JSON.stringify(this.siteComponents))).forEach(([key, item]) => {
          key;
          if (item.type === "PAGE") {
            object_list.push(item);
          }
        });
      }
      return object_list;
    },
    permissionCurrency() {
      return this.currencyMain == 'THB'
    },
  },
};
</script>

<style>
</style>